<template>
    <div class="contentbox setaddress">
      <div class="toptitle">
        <span class="return">
          <!--<router-link tag="span" :to="'/shoppingcart?id='+$route.query.id">&lt;</router-link>-->
           <span @click="$router.go(-1)">&lt;</span>
        </span>
        選擇收貨地址
        <!--<span @click="gps" class="topimgbox personalicon">-->
          <!--GPS-->
        <!--</span>-->
        <span @click="onsave" class="topimgbox">
          保存
        </span>
      </div>
      <div class="setaddressbox">
        <div class="pac-card" id="pac-card">
          <div id="pac-container">
            <input id="pac-input" type="text"
                   v-model="inputValue"
                   placeholder="Enter a location">
          </div>
        </div>
        <div id="infowindow-content">
          <img src="" width="16" height="16" id="place-icon">
          <span id="place-name"  class="title"></span><br>
          <span id="place-address"></span>
        </div>
        <div id="map" class="PersonalCenter">
        </div>
        <!--座楼室选择版本-->
        <!--<div class="showbut" @click="showPersonalCenter">-->
          <!--{{address.join('')}}-->
        <!--</div>-->
        <!--座楼室输入版本-->
        <div class="showbut">
          <input type="text" v-model="Seat">座
          <input type="text" v-model="floor">楼
          <input type="text" v-model="room">室
        </div>
      </div>
      <mt-popup
        v-model="popupVisible"
        :modal="false"
        position="bottom">
        <slot>
          <div class="selectRoomNumber">
            <Picker :slots="slots"
                    :visibleItemCount="5"
                    @change="onValuesChange"></Picker>
          </div>
        </slot>
      </mt-popup>
    </div>
</template>

<script>
  import { MessageBox,Button,Radio,Toast,Picker,Popup } from 'mint-ui';
  import {getDeliveryAddressGroup,geocode} from '../assets/js/api'
  import BMap from 'BMap'
    export default {
        name: "setaddress",
        data(){
          return{
            value:'',
            inputValue:'',
            popupVisible:false,
            maps:'',
            markersArray:[],
            marker:'',
            slots: [],
            Receivingaddress:[],
            select_room_number:["A", "1", "A", ""],
            address:["A", "座", "1", "楼", "A", "室"],
            latLngData:'',
            Seat:'1',
            floor:'1',
            room:'1',

          }
        },
        components:{
          Radio,
          MessageBox,
          Toast,
          Picker,
          Popup
        },
      mounted: function () {
        this.initMap()
        //处理座楼室的选项
        let slotnumber = []
        let slotLetter = []
        this.slots = [
          {
            flex: 1,
            values: ['0'],
            className: 'slotLetter',
            textAlign: 'right',
            defaultIndex: 0
          },
          {
            divider: true,
            content: '座',
            className: 'slot2',
            values: [],
            defaultIndex: 1
          },
          {
            flex: 1,
            values: ['0', '1', '2', '3', '4', '5'],
            className: 'slotnumber',
            textAlign: 'right',
            defaultIndex: 0
          },
          {
            divider: true,
            content: '楼',
            className: 'slot2',
            values: [],
          },
          {
            flex: 1,
            values: ['0'],
            className: 'slotLetter',
            textAlign: 'right',
            defaultIndex: 0
          },
          {
            divider: true,
            content: '室',
            className: 'slot2',
            values: [],
          },
          {
            flex: 0.5,
            values: [''],
            className: 'slot3',
            textAlign: 'left'
          },
        ]
        for (let i = 1; i < 71; i++) {
          slotnumber.push(i.toString())
        }
        for (let i = 0; i < 15; i++) {
          slotLetter.push(String.fromCharCode((65 + i)))
        }
        this.slots.map(itme => {
          if (itme.className === 'slotLetter') {
            itme.values = slotLetter.concat(slotnumber)
          }
          else if (itme.className === 'slotnumber') {
            itme.values = slotnumber
          }
        })
        //回写地址和座楼室

        if (this.$store.state.userdata.Receivingaddress) {
          this.inputValue = this.$store.state.userdata.Receivingaddress.split(' ')[0]
          this.Receivingaddress = this.$store.state.userdata.Receivingaddress.split(' ')[1]
          if (this.Receivingaddress) {
            this.address = []
            this.address.push(this.Receivingaddress.split('座')[0])
            this.address.push('座')
            this.address.push(this.Receivingaddress.split('座')[1].split('楼')[0])
            this.address.push('楼')
            this.address.push(this.Receivingaddress.split('楼')[1].split('室')[0])
            this.address.push('室')
            this.select_room_number[0] = this.Receivingaddress.split('座')[0]
            this.select_room_number[1] = this.Receivingaddress.split('座')[1].split('楼')[0]
            this.select_room_number[2] = this.Receivingaddress.split('楼')[1].split('室')[0]
            //输入座楼室
            this.Seat = this.Receivingaddress.split('座')[0]
            this.floor = this.Receivingaddress.split('座')[1].split('楼')[0]
            this.room = this.Receivingaddress.split('楼')[1].split('室')[0]
          }
        }
        if (this.address.length) {
          this.slots.map((itme, index) => {
            itme.values.map((list, i) => {
              if (this.address[index]) {
                if (list === this.address[index]) {
                  itme.defaultIndex = i
                }
              }
            })
          })
        }
      },
      methods:{
        initMap() {
          let geolocation = new BMap.Geolocation();
          geolocation.getCurrentPosition((r)=>{

            if(geolocation.getStatus() === BMAP_STATUS_SUCCESS){
              this.newmap(r.point.lng,r.point.lat)
            }
            else {
              this.newmap()
            }
          },{enableHighAccuracy: true})
        },
        newmap(longitude = 114.170730,latitude = 22.318995){
          // 获取经纬度初始化地图
          google ? google : {}
          this.maps = new google.maps.Map(document.getElementById("map"), {
            zoom: 14,
            //设置地图中心点
            center: { lng: longitude, lat: latitude },
            //为了关闭默认控件集,设置地图的disableDefaultUI的属性为true
            disableDefaultUI: true,
            // 启用缩放和平移
            gestureHandling: "greedy",
            // hybrid包含卫星和地名
            // mapTypeId: "hybrid",
            //语言可选值：en，zh_en, zh_cn
            language: "zh_cn"
          });
          // 给初始化的地图添加点击事件
          this.maps.addListener('click', (e)=> {
            this.addMarker(e.latLng, this.maps);
            //根据经纬度获取 当前地理信息
            this.latLngData = e.latLng.lat().toFixed(6)+','+e.latLng.lng().toFixed(6);
            geocode(this.latLngData).then(data=>{
              let address = data.plus_code.compound_code.split(' ')[1]
              if (data.results.length) {
                address = data.results[0].formatted_address.split(' ')[0]
              }
              let site = `<p style="color: #000">${address}<p/>`;
              let infowindow = new google.maps.InfoWindow({
                content: site
              });
              this.inputValue = address
              infowindow.open(this.maps,this.marker); //弹出信息提示窗口
            })
          });

          // 地址检索
          let card = document.getElementById('pac-card');
          let input = document.getElementById('pac-input');
          let types = document.getElementById('type-selector');
          let strictBounds = document.getElementById('strict-bounds-selector');

          this.maps.controls[google.maps.ControlPosition.TOP_RIGHT].push(card);

          let autocomplete = new google.maps.places.Autocomplete(input);

          // Bind the map's bounds (viewport) property to the autocomplete object,
          // so that the autocomplete requests use the current map bounds for the
          // bounds option in the request.
          autocomplete.bindTo('bounds', this.maps);

          // Set the data fields to return when the user selects a place.
          autocomplete.setFields(
            ['address_components', 'geometry', 'icon', 'name']);

          let infowindow = new google.maps.InfoWindow();
          let infowindowContent = document.getElementById('infowindow-content');
          infowindow.setContent(infowindowContent);
          let marker = new google.maps.Marker({
            map: this.maps,
            anchorPoint: new google.maps.Point(0, -29)
          });

          autocomplete.addListener('place_changed', ()=> {

            infowindow.close();
            marker.setVisible(false);
            let place = autocomplete.getPlace();
            console.log(place,'????')
            this.latLngData = place.geometry.viewport.na.j + ',' + place.geometry.viewport.ga.j
            if (!place.geometry) {
              // User entered the name of a Place that was not suggested and
              // pressed the Enter key, or the Place Details request failed.
              window.alert("No details available for input: '" + place.name + "'");
              return;
            }

            // If the place has a geometry, then present it on a map.
            if (place.geometry.viewport) {
              this.maps.fitBounds(place.geometry.viewport);
            } else {
              this.maps.setCenter(place.geometry.location);
              this.maps.setZoom(17);  // Why 17? Because it looks good.
            }
            marker.setPosition(place.geometry.location);
            marker.setVisible(true);

            let address = '';
            if (place.address_components) {
              address = [
                (place.address_components[0] && place.address_components[0].short_name || ''),
                (place.address_components[1] && place.address_components[1].short_name || ''),
                (place.address_components[2] && place.address_components[2].short_name || '')
              ].join(' ');
            }

            infowindowContent.children['place-icon'].src = place.icon;
            infowindowContent.children['place-name'].textContent = place.name;
            infowindowContent.children['place-address'].textContent = address;
            this.inputValue = document.getElementById('pac-input').value
            infowindow.open(this.maps, marker);
          });

        },
        addMarker(latLng, map) {
          if(this.markersArray.length>0){
            this.markersArray[0].setMap(null);
          };
          this.markersArray.shift(this.marker)
          this.marker = new google.maps.Marker({
            position: latLng,
            map: map
          });
          this.markersArray.push(this.marker);
        },
        onValuesChange(picker, values) {
          if (values.length) {
            this.select_room_number = values
            let selectRoomNumber = ''
            this.select_room_number.map((itme,index)=>{
              if (index===0){
                selectRoomNumber += itme+'座'
              }
              else if (index===1) {
                selectRoomNumber += itme+'楼'
              }
              else if (index === 2){
                selectRoomNumber += itme + '室'
              }
            })
            if (selectRoomNumber) {
              this.address = []
              this.address.push(selectRoomNumber.split('座')[0])
              this.address.push('座')
              this.address.push(selectRoomNumber.split('座')[1].split('楼')[0])
              this.address.push('楼')
              this.address.push(selectRoomNumber.split('楼')[1].split('室')[0])
              this.address.push('室')
            }
          }
        },
        onsave(){
          //输入座楼室
          let selectRoomNumber = this.Seat + '座' + this.floor + '楼' + this.room + '室'
          //选择座楼室
          // this.select_room_number.map((itme,index)=>{
          //   if (index===0){
          //     selectRoomNumber += itme+'座'
          //   }
          //   else if (index===1) {
          //     selectRoomNumber += itme+'楼'
          //   }
          //   else if (index === 2){
          //     selectRoomNumber += itme + '室'
          //   }
          // })
          let obj = {
            address : this.inputValue.replace(/\s/g,'')+' '+selectRoomNumber,
            latLngData : this.latLngData
          }
          this.$store.commit('setReceivingaddress',obj)
          this.$router.go(-1)
        },
        showPersonalCenter(){
          this.popupVisible ? this.popupVisible = false : this.popupVisible = true
        },
      },
      computed:{
      }
    }
</script>

<style lang="less">
  @import "../assets/less/base";
  #app{
    .contentbox.setaddress{
      background-color: #fff;
      width: 100%;
      z-index: 2007!important;
      .toptitle{
        position: fixed;
        z-index: 2008;
        background-color: @maincolor;
        height: 52px;
        font-size: 16px;
        line-height: 52px;
        color: #fff;
        box-shadow: 0px 2px 5px 2px #e8e8e8;
        text-align: center;
        display: flex;
        justify-content: space-between;
        width: 90%;
        padding: 0 5%;
        .return{
          font-size: 40px;
          cursor: pointer;
        }
        .topimgbox{
          cursor: pointer;
        }
      }
      .setaddressbox{
        position: relative;
        .title{
          margin: 0.4rem;
          font-size: 16px;
        }
        >ul{
          margin-top: 0.2rem;
          border-top: 1px solid #f2f2f2;
          >li{
            cursor: pointer;
          }
          li{
            margin-top: 0.2rem;
            margin-left: 0.2rem;
            height: 30px;
            overflow: hidden;
            font-size: 16px;
            &.show{
              height: auto;
            }
            /*padding-left: 0.2rem;*/
            .mint-radiolist-label{
              cursor: pointer;
            }
          }
        }
        .showbut{
          width: 150px;
          height: 40px;
          position: absolute;
          top: 120px;
          left: 5%;
          background: #fff;
          text-align: center;
          line-height: 40px;
          @media (min-width: @screen-xs-max) {
            left: 50px;
          }
          input{
            border-bottom: 1px solid #000;
            display: inline-block;
            width: 20%;
            text-align: center;
          }
        }
      }
      .mint-popup{
        width: 100%;
        height: 200px;
        .selectRoomNumber{
          background: #fff;
          width: 100%;
          bottom: 50px;
          padding: 10px 0;
          .picker-items{
            .slotLetter,.slotnumber{
              .picker-item{
                cursor: pointer;
              }
            }
            .picker-center-highlight{
              /*display: none;*/
            }
          }

        }
      }
      .PersonalCenter{
        width: 100% !important;
        height: 96vh;
        .gm-china{
          a{
            >div{
              >img{
                display: none;
              }
            }
          }
        }
        .gmnoprint,.gm-style-cc{
          display: none;
        }
        #infowindow-content{
          #place-name,#place-address{
            color: #000;
          }
        }
      }
      .pac-card {
        margin: 10px 10px 0 0;
        border-radius: 2px 0 0 2px;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        outline: none;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
        background-color: #fff;
        font-family: Roboto;
        top: 50px !important;
        left: 5% !important;
        width: 85%;
        @media (min-width: @screen-xs-max) {
          left: 50px !important;
          top: 40px !important;
          width: 400px;
        }
      }
      #pac-container {
        margin-right: 12px;
      }
      .pac-controls {
        display: inline-block;
        padding: 5px 11px;
      }
      .pac-controls label {
        font-family: Roboto;
        font-size: 13px;
        font-weight: 300;
      }
      #pac-input {
        background-color: #fff;
        font-family: Roboto;
        font-size: 15px;
        font-weight: 300;
        margin-left: 12px;
        padding: 0 11px 0 13px;
        text-overflow: ellipsis;
        width: 100%;
        height: 40px;
      }
      #pac-input:focus {
        border-color: #4d90fe;
      }

    }

  }
  #gpsbut{
    margin-right: 20px;
    color: #979797;
    float: right;
    cursor: pointer;
  }
  .pac-container{
    left: 10%;
    z-index: 9999999 !important;
    @media (min-width: @screen-xs-max) {
      left: 50px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/setaddress.vue